import React from "react";
import ReactMarkdown from "react-markdown";

/**
 * Minimal Markdown renderer with Tailwind-typography-like styling.
 * Centralised so all premium content (Research Ideas, Paper Explainers,
 * Discussions, Course descriptions) renders consistently.
 */
export default function MarkdownView({ source = "" }) {
  if (!source) return null;
  return (
    <ReactMarkdown
      components={{
        h1: ({ node, ...p }) => <h1 className="font-serif text-2xl text-kb-ink mt-4 mb-2" {...p} />,
        h2: ({ node, ...p }) => <h2 className="font-serif text-xl text-kb-ink mt-4 mb-2" {...p} />,
        h3: ({ node, ...p }) => <h3 className="font-serif text-lg text-kb-ink mt-3 mb-1.5" {...p} />,
        p: ({ node, ...p }) => <p className="text-sm text-kb-ink leading-relaxed my-2" {...p} />,
        a: ({ node, ...p }) => <a {...p} target="_blank" rel="noreferrer" className="text-kb-primary underline-offset-2 hover:underline" />,
        ul: ({ node, ...p }) => <ul className="list-disc list-outside pl-5 my-2 text-sm text-kb-ink space-y-1" {...p} />,
        ol: ({ node, ...p }) => <ol className="list-decimal list-outside pl-5 my-2 text-sm text-kb-ink space-y-1" {...p} />,
        li: ({ node, ...p }) => <li className="leading-relaxed" {...p} />,
        code: ({ node, inline, ...p }) =>
          inline
            ? <code className="kb-mono text-[12px] px-1.5 py-0.5 rounded bg-slate-100 text-kb-ink" {...p} />
            : <code className="kb-mono text-[12px] block" {...p} />,
        pre: ({ node, ...p }) => <pre className="kb-mono text-[12px] bg-slate-900 text-slate-100 p-3 rounded-sm overflow-x-auto my-3" {...p} />,
        blockquote: ({ node, ...p }) => <blockquote className="border-l-2 border-kb-primary pl-3 my-2 text-sm text-kb-ink-muted italic" {...p} />,
        strong: ({ node, ...p }) => <strong className="text-kb-ink font-semibold" {...p} />,
        em: ({ node, ...p }) => <em className="italic text-kb-ink" {...p} />,
        hr: () => <hr className="my-4 border-slate-200" />,
        table: ({ node, ...p }) => <table className="text-sm border-collapse my-3" {...p} />,
        th: ({ node, ...p }) => <th className="border border-slate-200 px-2 py-1 bg-slate-50 text-left" {...p} />,
        td: ({ node, ...p }) => <td className="border border-slate-200 px-2 py-1" {...p} />,
      }}
    >
      {source}
    </ReactMarkdown>
  );
}
